<template>
  <div class="tournament-content-tab tab-sportsmans" v-bind:class="{'tournament-content-active-tab':activeTab == 2}">

    <!-- Шапка: заголовок, прогрес перевірки, дії -->
    <section class="panel sp-head">
      <div class="sp-head-main">
        <div class="sp-title">
          <h3>Спортсмени <span class="sp-count">{{ allSportsmans.length }}</span></h3>
          <div class="sp-progress" v-if="allSportsmans.length > 0">
            <div class="sp-progress-text">
              <span>Перевірено <b>{{ verifiedCount }}</b> з {{ allSportsmans.length }}</span>
              <span class="sp-progress-pct">{{ progressPercent }}%</span>
            </div>
            <div class="sp-progress-bar" role="progressbar" :aria-valuenow="progressPercent" aria-valuemin="0" aria-valuemax="100">
              <span :style="{width: progressPercent + '%'}"></span>
            </div>
          </div>
        </div>

        <div class="sp-actions">
          <button type="button" class="sp-btn sp-btn-primary" @click="toogleAddSportsman()">
            <span aria-hidden="true"><tkd-icon name="plus"/></span> Додати
          </button>
          <button type="button" class="sp-btn" @click="syncData()">
            <span aria-hidden="true"><tkd-icon name="refresh"/></span> Синхронізація
          </button>
        </div>
      </div>

      <div class="sp-head-bulk">
        <span class="sp-bulk-label">Масові дії:</span>
        <button type="button" class="sp-btn sp-btn-sm sp-btn-success" @click="verifyAllSportsman(1)">
          <span aria-hidden="true"><tkd-icon name="check-circle"/></span> Підтвердити всіх
        </button>
        <button type="button" class="sp-btn sp-btn-sm sp-btn-danger" @click="verifyAllSportsman(0)">
          <span aria-hidden="true"><tkd-icon name="x-circle"/></span> Скасувати всім
        </button>
        <button type="button" class="sp-btn sp-btn-sm sp-btn-ghost" @click="addTestData()" :disabled="isLoadingTestData" title="Створити 25 тестових спортсменів">
          <span aria-hidden="true" :class="{'sp-spin': isLoadingTestData}"><tkd-icon :name="isLoadingTestData ? 'loader' : 'flask'"/></span>
          {{ isLoadingTestData ? 'Створення...' : 'Додати тестові дані' }}
        </button>
      </div>
    </section>

<!--          Форма добавления спортсмена-->
    <modal name="sportsman-form-modal" classes="v--modal adm-modal" :adaptive=true :minHeight=350 height="auto" :minWidth=320 width="92%" :maxWidth=880 :scrollable=true>
      <form-sportsman :formAddSportsman="formAddSportsman"></form-sportsman>
    </modal>

<!--          Форма добавления спортсмена-->
    <modal name="sportsmansync-form-modal" :adaptive=true  :minHeight=350 height="auto" :minWidth=400 width="80%" :scrollable=true >
      <div class="mr-5">
        Синхронізація даних. Зачекайте...
      </div>
    </modal>

    <!-- Фільтри -->
    <section class="panel sp-filters">
      <div class="sp-filter-grid">
        <div class="sp-field">
          <label class="sp-label">Область</label>
          <v-select label="name" :filterable="true" :options="regionsList"
                    v-model="filterSportsmansRegionVal" >
            <template slot="no-options">Укажіть область
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <span class="name-city">{{option.count > 0 ? option.count+' | ' : ''}}{{ option.name }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
          </v-select>
        </div>

        <div class="sp-field">
          <label class="sp-label">Категорія</label>
          <v-select label="name" :filterable="true" :options="filterProtocols"
                    v-model="filterSportsmansCategoryVal" >
            <template slot="no-options">Укажіть категорію
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <span class="name-city">{{option.count > 0 ? option.count+' | ' : ''}}{{ option.name }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
          </v-select>
        </div>

        <div class="sp-field">
          <label class="sp-label">Організація</label>
          <v-select label="name" :filterable="true" :options="filterOrganization"
                    v-model="filterSportsmansOrganizationVal" >
            <template slot="no-options">Укажіть організацію
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
          </v-select>
        </div>

        <div class="sp-field">
          <label class="sp-label">Тренер</label>
          <v-select label="name" :filterable="true" :options="filterTrainer"
                    v-model="filterSportsmansTrainerVal" >
            <template slot="no-options">Укажіть тренера
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
          </v-select>
        </div>
      </div>

      <div class="sp-filter-bar">
        <div class="segmented" role="tablist" aria-label="Статус перевірки">
          <button type="button" v-for="s in statusTabs" :key="s.id"
                  :class="{active: filterStatus === s.id}" :aria-selected="filterStatus === s.id"
                  @click="filterStatus = s.id">
            {{ s.label }} <span class="seg-count">{{ s.count }}</span>
          </button>
        </div>

        <div class="sp-search">
          <span class="sp-search-icon" aria-hidden="true"><tkd-icon name="search"/></span>
          <input type="search" v-model.trim="searchName" placeholder="Пошук за ім'ям або ID" aria-label="Пошук спортсмена">
        </div>

        <button type="button" class="sp-btn sp-btn-sm sp-btn-ghost" v-if="hasActiveFilters" @click="resetFilters()">
          Скинути фільтри
        </button>
      </div>
    </section>

    <!-- Таблиця -->
    <section class="panel sp-table-panel" v-if="visibleSportsmans.length > 0">
      <div class="sp-table-meta">
        <span>Показано <b>{{ visibleSportsmans.length }}</b> з {{ allSportsmans.length }}</span>
        <span class="sp-legend">
          <span class="lg lg-done"></span>перевірено
          <span class="lg lg-warn"></span>неповні дані
        </span>
      </div>

      <div class="sp-table-wrap">
        <table class="sp-table">
          <thead>
          <slot name="columns">
            <tr>
              <th class="col-check">Перевірка</th>
              <th class="col-id">ID</th>
              <th>Ім'я</th>
              <th>Область</th>
              <th>Рік нар.</th>
              <th>Стать</th>
              <th>Категорія</th>
              <th>Організація</th>
              <th>Кваліфікація</th>
              <th>Тренер</th>
              <th>Страховка</th>
              <!--                        <th>Бере участь</th>-->
              <th class="col-actions">Дії</th>
            </tr>
          </slot>
          </thead>
          <tbody>
          <tr :class="{'verified-sportsman': item.verification_status == 1, 'incomplete-sportsman': item.verification_status != 1 && missingCount(item) > 0}"
              v-for="(item, index) in visibleSportsmans" :key="item.id || index">
            <td class="col-check">
<!--                    {{item.verification_status}}-->
              <label class="sp-check" :class="{on: item.verification_status == 1}">
                <input :v-model="item.verification_status" @click="verificationStatusChanged(item)" class="input-checkbox" type="checkbox" :checked="item.verification_status == 1 ? true:false">
                <span>{{ item.verification_status == 1 ? 'Перевірено' : 'Перевірити' }}</span>
              </label>
<!--                    <base-checkbox :v-model="item.verification_status"></base-checkbox>-->
            </td>
            <td class="col-id">#{{item.id}}</td>
            <td class="col-name">
              <div class="sp-name-cell">
                <span class="sp-avatar" :style="{ backgroundColor: avatarBackground(item) }" :title="item.name || 'Спортсмен без імені'" aria-hidden="true">
                  {{ avatarInitials(item) }}
                </span>
                <span class="sp-name-content">
                  <span class="sp-name-text" v-if="item.name">{{ item.name }}</span>
                  <span class="missing" v-else>не вказано</span>
                  <span class="warn-note" v-if="item.verification_status != 1 && missingCount(item) > 0"><tkd-icon name="warning"/> бракує полів: {{ missingCount(item) }}</span>
                </span>
              </div>
            </td>
            <td>{{item.oblast}}<span class="missing" v-if="!item.oblast">не вказано</span></td>
            <td class="nowrap">{{item.bdate}}<span class="missing" v-if="!item.bdate">не вказано</span></td>
            <td class="nowrap"><span class="missing" v-if="!item.sex">не вказано</span><span class="chip chip-m" v-if="item.sex == 1">чоловік</span><span class="chip chip-f" v-if="item.sex == 2">жінка</span></td>
            <td>{{item.category}}<span class="missing" v-if="!item.category">не вказано</span></td>
            <td>{{item.organization}}<span class="missing" v-if="!item.organization">не вказано</span></td>
            <td>{{item.qualification}}<span class="missing" v-if="!item.qualification">не вказано</span></td>
            <td>{{item.coach}}<span class="missing" v-if="!item.coach">не вказано</span></td>

            <td>{{item.insurence}}<span class="muted" v-if="!item.insurence">—</span></td>

            <!--                      <td><span class="text-danger"><span class="text-danger"  v-if="item.is_not_found == 1">ні</span> <span class="text-primary"  v-else>так <span style="font-size: 12px!important; display: block"><span v-if="!item.protocol_name" class="text-warning"><b>??????????</b></span> <span v-else>{{item.protocol_name}} </span> </span></span></span></td>-->
            <td class="col-actions">
              <div class="row-actions">
                <button type="button" class="icon-btn icon-edit" @click="updateOneSportsman(item)" title="Редагувати" aria-label="Редагувати">
                  <tkd-icon name="edit"/>
<!--                      Редагувати-->
                </button>

                <button type="button" class="icon-btn icon-delete" @click="deleteOneSportsman(item.id)" title="Видалити" aria-label="Видалити">
                  <tkd-icon name="trash"/>
<!--                      Видалити-->
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!--                TODO Додати перевiрку на JS при створенні-редагуванні-->
    </section>

    <!-- Порожній стан -->
    <section class="sp-empty" v-else>
      <div class="sp-empty-icon" aria-hidden="true"><tkd-icon name="dobok"/></div>
      <template v-if="hasActiveFilters">
        <p>За вибраними фільтрами спортсменів не знайдено</p>
        <button type="button" class="sp-btn" @click="resetFilters()">Скинути фільтри</button>
      </template>
      <template v-else>
        <p>Інформація відсутня</p>
        <button type="button" class="sp-btn sp-btn-primary" @click="toogleAddSportsman()"><span aria-hidden="true"><tkd-icon name="plus"/></span> Додати спортсмена</button>
      </template>
    </section>
  </div>
</template>

<script>
  import 'src/assets/css/tkd-theme.css';
  import FormSportsman from  'src/pages/tournament/_formSportsman.vue';

  // поля, без яких запис вважається неповним
  const REQUIRED_FIELDS = ['name', 'oblast', 'bdate', 'sex', 'category', 'organization', 'qualification', 'coach'];
  export default {
    name: "tab-sportsmans",
    components:{
      'form-sportsman': FormSportsman
    },
    data: function(){
      return {
        formAddSportsman:{
          id:'',
          tournament:'',
          name:'',
          bdate:'',
          organization:'',
          qualification:'',
          sex:'',
          weight:'',
          coach:'',
          trainer2:'',
          category_id:'',
          oblast:'',
        },
        filterSportsmansEnabled:false,
        filterSportsmansOrganizationEnabled:false,
        filterSportsmansOrganizationVal:'',
        filterSportsmansTrainerVal:'',

        filterSportsmansCategoryEnabled:false,
        filterSportsmansCategoryVal:'',
        filterSportsmansRegionVal:'',
        isLoadingTestData: false,
        // локальні фільтри (без запитів до API)
        filterStatus: 'all',
        searchName: '',
      }
    },
    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },
      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      regionsList() {
        let regions = {};

        // Check if sportsmans data exists
        if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.sportsmans) {
          return [];
        }

        for (const sportsman of this.tournamentOne.data.item.sportsmans){

          if(regions[sportsman.oblast] != undefined){
            regions[sportsman.oblast]['count']++;
          }else{
            regions[sportsman.oblast] = {
              name: sportsman.oblast,
              count:  1
            }
          }
        }

        let regionsArr = [];
        let keys = Object.keys(regions);
        console.log('keys', keys)

        for (let i  in keys) {
          regionsArr.push(regions[keys[i]])
        }


        return  regionsArr.sort(function (a, b){
          if ( a.count > b.count ){
            return -1;
          }
          if ( a.count < b.count ){
            return 1;
          }
          return 0;
        });
      },
      filterProtocols: function() {
        let filters = [];
        let checkedFiters = this.tournamentOne.data.item.protocols;
        if(checkedFiters != undefined && checkedFiters != null && checkedFiters != ''){
          checkedFiters.forEach(element => {
            filters.push({name:element.fullname, val:element.id, count:element.count});
          });
        }

        return filters;
      },

      filteredSportsmans: function() {
        console.log('filteredSportsmans');
        let filters = [];
        if(this.tournamentOne.data.item.sportsmans){

          let sportsmansList = this.tournamentOne.data.item.sportsmans;

          let organization = this.filterSportsmansOrganizationVal;
          let category = this.filterSportsmansCategoryVal;
          let region = this.filterSportsmansRegionVal;
          let trainer = this.filterSportsmansTrainerVal;

          if (region != '' && region != undefined) {
            sportsmansList = sportsmansList.filter(function (el) {
              return el.oblast == region.name;
            });
          }


          if (organization != '' && organization != undefined) {
            sportsmansList = sportsmansList.filter(function (el) {
              return el.organization == organization.name;
            });
          }


          if (category != '' && category != undefined) {
            sportsmansList = sportsmansList.filter(function (el) {
              return  el.category_id == category.val;;
            });
          }


          if (trainer != '' && trainer != undefined) {
            sportsmansList = sportsmansList.filter(function (el) {
              return  el.coach == trainer.val || el.trainer2 == trainer.val || el.trainer3 == trainer.val;
            });
          }

          return sportsmansList;

          // если включен фильтр по организациям
          if(this.filterSportsmansOrganizationVal != '' && this.filterSportsmansOrganizationVal != undefined && this.filterSportsmansCategoryVal != '' && this.filterSportsmansCategoryVal != undefined ){

            let filtersTmp = [];
            let checkedFiters = this.tournamentOne.data.item.sportsmans.filter(function(el) {
              return el.organization == organization.name;
            });
            checkedFiters.forEach(element => {
              filtersTmp.push(element);
            });

            checkedFiters = filtersTmp.filter(function(el) {
              return el.category_id == category.val;
            });
            checkedFiters.forEach(element => {
              filters.push(element);
            });

          }else if(this.filterSportsmansOrganizationVal != '' && this.filterSportsmansOrganizationVal != undefined ){

            let checkedFiters = this.tournamentOne.data.item.sportsmans.filter(function(el) {
              return el.organization == organization.name;
            });
            checkedFiters.forEach(element => {
              filters.push(element);
            });

          }else if(this.filterSportsmansCategoryVal != '' && this.filterSportsmansCategoryVal != undefined){

            let checkedFiters = this.tournamentOne.data.item.sportsmans.filter(function(el) {
              return el.category_id == category.val;
            });

            checkedFiters.forEach(element => {
              filters.push(element);
            });


            // return this.tournamentOne.data.item.sportsmans;
          }else {
            return this.tournamentOne.data.item.sportsmans;
          }

          // если включен фильтр по категориям


        }
        // filters = this.tournamentOne.data.item.sportsmans;

        return filters;
      },



      filterOrganization: function() {
        let filters = [];
        let checkedFiters = this.tournamentOne.data.item.organizations;

        console.log(checkedFiters);

        if(checkedFiters != undefined && checkedFiters != null && checkedFiters != ''){
          checkedFiters.forEach(element => {
            filters.push({name:element.organization, val:element.oblast});
          });
        }

        return filters;
      },

       filterTrainer: function() {
        let filters = [];

        // Check if sportsmans data exists
        if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.sportsmans) {
          return [];
        }

         const isShallowEqualWith = (a) => (b) => {
           const keysA = Object.keys(a);
           const keysB = Object.keys(b);
           return keysA.length === keysB.length && keysA.every(k => a[k] === b[k]);
         }

         for (const sportsman of this.tournamentOne.data.item.sportsmans) {

           console.log('sportsman', sportsman);
           if (sportsman.coach) {
             let temp = {name: sportsman.coach, val: sportsman.coach}
             if(!filters.find(isShallowEqualWith(temp))) {
               filters.push(temp);
             }
             // filters.push(temp);
           }
           if (sportsman.trainer2) {
             let temp = {name: sportsman.trainer2, val: sportsman.trainer2}
             if(!filters.find(isShallowEqualWith(temp))) {
               filters.push(temp);
             }
             // filters.push({name: sportsman.trainer2, val: sportsman.trainer2});
           }
           if (sportsman.trainer3) {
             let temp = {name: sportsman.trainer3, val: sportsman.trainer3}
             // filters.push({name: sportsman.trainer3, val: sportsman.trainer3});
             if(!filters.find(isShallowEqualWith(temp))) {
               filters.push(temp);
             }
           }

         }

        return filters;
      },

      allSportsmans() {
        const t = this.tournamentOne;
        return t && t.data && t.data.item && t.data.item.sportsmans ? t.data.item.sportsmans : [];
      },
      verifiedCount() {
        return this.allSportsmans.filter(s => s.verification_status == 1).length;
      },
      progressPercent() {
        return this.allSportsmans.length ? Math.round(this.verifiedCount * 100 / this.allSportsmans.length) : 0;
      },
      statusTabs() {
        const list = this.filteredSportsmans || [];
        const done = list.filter(s => s.verification_status == 1).length;
        return [
          {id: 'all', label: 'Всі', count: list.length},
          {id: 'todo', label: 'Не перевірені', count: list.length - done},
          {id: 'done', label: 'Перевірені', count: done},
          {id: 'incomplete', label: 'Неповні дані', count: list.filter(s => this.missingCount(s) > 0).length},
        ];
      },
      // filteredSportsmans + статус перевірки + пошук
      visibleSportsmans() {
        let list = this.filteredSportsmans || [];
        if (this.filterStatus === 'todo') list = list.filter(s => s.verification_status != 1);
        if (this.filterStatus === 'done') list = list.filter(s => s.verification_status == 1);
        if (this.filterStatus === 'incomplete') list = list.filter(s => this.missingCount(s) > 0);
        const q = this.searchName.toLowerCase();
        if (q) list = list.filter(s => String(s.name || '').toLowerCase().includes(q) || String(s.id) === q);
        return list;
      },
      hasActiveFilters() {
        return !!(this.filterSportsmansRegionVal || this.filterSportsmansCategoryVal || this.filterSportsmansOrganizationVal
          || this.filterSportsmansTrainerVal || this.searchName || this.filterStatus !== 'all');
      },

      actionTournamentAddSportsman() {
        return this.$store.getters['settings/actionTournamentAddSportsman'];
      },

    },
    methods:{

      missingCount(item) {
        return REQUIRED_FIELDS.filter(f => !item[f]).length;
      },

      avatarInitials(item) {
        const parts = String(item && item.name || '').trim().split(/\s+/).filter(Boolean);
        if (!parts.length) {
          return '?';
        }
        if (parts.length === 1) {
          return parts[0].slice(0, 2).toUpperCase();
        }
        return (parts[1][0] + parts[0][0]).toUpperCase();
      },

      avatarBackground(item) {
        const seed = item && item.id !== undefined && item.id !== null && item.id !== ''
          ? String(item.id)
          : String(item && item.name || '');
        let hash = 0;

        for (let i = 0; i < seed.length; i++) {
          hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
        }

        return `hsl(${hash % 360}, 55%, 89%)`;
      },

      resetFilters() {
        this.filterSportsmansRegionVal = '';
        this.filterSportsmansCategoryVal = '';
        this.filterSportsmansOrganizationVal = '';
        this.filterSportsmansTrainerVal = '';
        this.searchName = '';
        this.filterStatus = 'all';
      },



      toogleAddSportsman(){
        // добавление участника
        // if(this.actionTournamentAddSportsman == true){
        //   this.$store.dispatch('settings/setActionTournamentAddSportsman',false);
        // }else{
        //   this.$store.dispatch('settings/setActionTournamentAddSportsman',true);
        // }

        this.$store.dispatch('settings/setActionTournamentAddSportsman',true);
        this.$modal.show('sportsman-form-modal');

      },

      syncData(){
        // добавление участника
        // if(this.actionTournamentAddSportsman == true){
        //   this.$store.dispatch('settings/setActionTournamentAddSportsman',false);
        // }else{
        //   this.$store.dispatch('settings/setActionTournamentAddSportsman',true);
        // }

        this.$modal.show('sportsmansync-form-modal');
        // this.$store.dispatch('settings/setActionTournamentAddSportsman',true);
        let params = {'id': this.tournamentOne.data.item.id};
        this.$store.dispatch('tournament/syncTournamentSportsmans', params).then(() => this.fetchTournamentOneFull());
      },

      fetchTournamentOneFull(){
        console.log('fetchTournamentOneFull!!');
        console.log('tournamentOnetournamentOne',this.tournamentOne.data);
        this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id});
        this.$modal.hide('sportsmansync-form-modal');
      },


      updateOneSportsman(sportsman){
        console.log(sportsman);

        // this.formAddSportsman.first_name = sportsman.first_name;
        // this.formAddSportsman.last_name = sportsman.last_name;
        this.formAddSportsman.name = sportsman.name;
        this.formAddSportsman.tournament = sportsman.tournament;
        this.formAddSportsman.organization = sportsman.organization;
        this.formAddSportsman.qualification = sportsman.qualification;
        this.formAddSportsman.sex = sportsman.sex;

        if(sportsman.sex == 0){
          this.formAddSportsman.sex = {id:0, name:'-'};
        }else if(sportsman.sex == '1'){
          this.formAddSportsman.sex =  {id:1, name:'чоловік'};
        }else if(sportsman.sex == '2'){
          this.formAddSportsman.sex = {id:2, name:'жінка'};
        }

        this.formAddSportsman.weight = sportsman.weight;
        this.formAddSportsman.coach = sportsman.coach;
        this.formAddSportsman.trainer2 = sportsman.trainer2;
        this.formAddSportsman.category_id = sportsman.category_id;
        this.formAddSportsman.oblast = sportsman.oblast;
        this.formAddSportsman.bdate = sportsman.bdate;
        this.formAddSportsman.id = sportsman.id;


        for (let i = 0; i <  this.tournamentOne.data.item.protocols.length ; i++) {
          if(this.tournamentOne.data.item.protocols[i].id == sportsman.category_id){
            this.formAddSportsman.category_id = this.tournamentOne.data.item.protocols[i];
            break;
          }

        }

        console.log(this.formAddSportsman);




        this.$store.dispatch('settings/setActionTournamentAddSportsman',true);
        this.$modal.show('sportsman-form-modal');
        // form

      },

      // удаление одного спортсмена  с турнира
      deleteOneSportsman(id){
        if (window.confirm(" Після видалення дані неможливо буде відновити. Ви впевнені, що хочете видали спортсмена з турніру?")) {
          let params = {'id': id};
          this.$store.dispatch('tournament/deleteOneSportsman', params)
            .then(() => this.deleteFromListSportsman(id));
        }
      },

      verificationStatusChanged(item){
        if(item.verification_status == 1) item.verification_status = 0;
        if(item.verification_status == 0) item.verification_status = 1;


        let params = {'id': item.id, 'verification_status':item.verification_status};


        this.$store.dispatch('tournament/verifyOneSportsman', params)
          .then(() => this.fetchTournamentOneFull(item.tournament_id)).then(()=>this.sportsmanVerificationStatusChanged());
      },

      verifyAllSportsman(verification_status) {
        const params = {
          tournament_id: this.tournamentOne.data.item.id,
          verification_status,
        };

        this.$store.dispatch('tournament/verifyAllSportsman', params)
          .then(() => this.fetchTournamentOneFull())
          .then(() => {
            this.$notify({
              text: verification_status === 1 ? 'Всіх спортсменів підтверджено' : 'Підтвердження всіх спортсменів скасовано',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 10000,
              speed: 1000,
              type: 'success'
            });
          });
      },

      sportsmanVerificationStatusChanged(){
        this.$notify(
          {
            text: 'Статус перевірк оновлено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'success'
          })
      },

      deleteFromListSportsman(id){
        let length = this.tournamentOne.data.item.sportsmans.length;
        for (let i = 0; i < length; i++) {
          console.log(this.tournamentOne.data.item.sportsmans[i].id);
          if (this.tournamentOne.data.item.sportsmans[i].id === id){
            this.tournamentOne.data.item.sportsmans.splice(i, 1);
            break;
          }
        }
      },

      // Додати тестові дані - 16 спортсменів
      async addTestData() {
        // Перевірка чи є категорії
        if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols || this.tournamentOne.data.item.protocols.length === 0) {
          alert('Немає категорій у турнірі. Спочатку додайте категорії.');
          return;
        }

        if (!confirm('Створити 25 тестових спортсменів для першої категорії?')) {
          return;
        }

        // Встановлюємо стан завантаження
        this.isLoadingTestData = true;

        try {
          // Взяти першу категорію
          const firstCategory = this.tournamentOne.data.item.protocols[0];
          console.log('🔍 Перша категорія:', firstCategory);
          console.log('🔍 Стать категорії:', firstCategory.sex, 'Type:', typeof firstCategory.sex);

        // Українські прізвища та імена
        const lastNames = [
          'Коваленко', 'Мельник', 'Шевченко', 'Бойко', 'Поліщук',
          'Гриценко', 'Кравченко', 'Мороз', 'Сидоренко', 'Литвиненко',
          'Бондаренко', 'Коваль', 'Павленко', 'Горбач', 'Ковальчук',
          'Зайцев', 'Руденко', 'Савченко', 'Нечипоренко', 'Ткаченко'
        ];

        const maleFirstNames = [
          'Андрій', 'Олександр', 'Дмитро', 'Іван', 'Микола',
          'Владислав', 'Сергій', 'Володимир', 'Євген', 'Віктор',
          'Артем', 'Василь', 'Богдан', 'Михайло', 'Арсен'
        ];

        const femaleFirstNames = [
          'Олена', 'Марія', 'Анна', 'Ірина', 'Катерина',
          'Ольга', 'Наталія', 'Юлія', 'Вікторія', 'Тетяна',
          'Софія', 'Анастасія', 'Дарина', 'Людмила', 'Валентина'
        ];

        const malePatronymics = [
          'Андрійович', 'Олександрович', 'Дмитрович', 'Іванович', 'Миколайович',
          'Владиславович', 'Сергійович', 'Володимирович', 'Євгенович', 'Вікторович',
          'Васильович', 'Петрович', 'Павлович', 'Романович', 'Степанович'
        ];

        const femalePatronymics = [
          'Андрійівна', 'Олександрівна', 'Дмитрівна', 'Іванівна', 'Миколаївна',
          'Владиславівна', 'Сергіївна', 'Володимирівна', 'Євгенівна', 'Вікторівна',
          'Василівна', 'Петрівна', 'Павлівна', 'Романівна', 'Степанівна'
        ];

        // 8 областей і організацій
        const regions = [
          'Київська',
          'Львівська',
          'Харківська',
          'Дніпропетровська',
          'Одеська',
          'Запорізька',
          'Івано-Франківська',
          'Вінницька'
        ];

        const organizations = [
          'ДЮСШ "Олімп"',
          'СК "Чемпіон"',
          'ДЮСШ "Спарта"',
          'СК "Динамо"',
          'ДЮСШ "Лідер"',
          'СК "Вітязь"',
          'ДЮСШ "Енергія"',
          'СК "Перемога"'
        ];

        const coaches = [
          'Петренко Петро Петрович',
          'Іванов Іван Іванович',
          'Сидоров Сидір Сидорович',
          'Коваль Олексій Васильович',
          'Бойко Василь Миколайович',
          'Мельник Андрій Олександрович',
          'Шевченко Дмитро Вікторович',
          'Литвиненко Сергій Володимирович'
        ];

        const qualifications = ['KMS', 'I розряд', 'II розряд', 'III розряд', '1 Дан', '2 Дан'];

        // Визначити вагу для категорії
        let weight = '45'; // По замовчуванню
        if (firstCategory.weight1 && firstCategory.weight1 !== '') {
          weight = firstCategory.weight1;
        }

        // Визначити рік народження на основі вікової категорії
        const currentYear = new Date().getFullYear();
        let birthYear = currentYear - 14; // По замовчуванню
        if (firstCategory.age1) {
          birthYear = currentYear - parseInt(firstCategory.age1);
        }

        // Стать (з категорії) - перетворюємо в число
        let sex = parseInt(firstCategory.sex) || 0; // 0 - не вказано, 1 - чоловік, 2 - жінка
        console.log('🔍 Використовувана стать:', sex, 'Type:', typeof sex);

        const sportsmen = [];
        let successCount = 0;
        let failCount = 0;

        // Створюємо 25 спортсменів: по 3 з перших 8 областей (24) + 1 додатковий
        const totalSportsmen = 25;
        const sportmenPerRegion = 3;
        
        for (let regionIndex = 0; regionIndex < regions.length; regionIndex++) {
          const region = regions[regionIndex];
          const organization = organizations[regionIndex];
          const coach = coaches[regionIndex];

          for (let i = 0; i < sportmenPerRegion; i++) {
            const useSex = sex === 0 ? (Math.random() > 0.5 ? 1 : 2) : sex;
            console.log(`👤 Генеруємо спортсмена зі статтю: ${useSex} (категорія sex: ${sex})`);
            
            const firstName = useSex === 1 
              ? maleFirstNames[Math.floor(Math.random() * maleFirstNames.length)]
              : femaleFirstNames[Math.floor(Math.random() * femaleFirstNames.length)];
            
            const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
            const patronymic = useSex === 1
              ? malePatronymics[Math.floor(Math.random() * malePatronymics.length)]
              : femalePatronymics[Math.floor(Math.random() * femalePatronymics.length)];
            const qualification = qualifications[Math.floor(Math.random() * qualifications.length)];

            const sportsman = {
              tournament: this.tournamentOne.data.item.id,
              name: `${lastName} ${firstName} ${patronymic}`,
              bdate: birthYear,
              organization: organization,
              qualification: qualification,
              sex: useSex,
              weight: weight,
              coach: coach,
              trainer2: '',
              category_id: firstCategory.id,
              oblast: region,
            };

            sportsmen.push(sportsman);
          }
        }
        
        // Додаємо 1 додаткового спортсмена з першої області
        const useSex = sex === 0 ? (Math.random() > 0.5 ? 1 : 2) : sex;
        const firstName = useSex === 1 
          ? maleFirstNames[Math.floor(Math.random() * maleFirstNames.length)]
          : femaleFirstNames[Math.floor(Math.random() * femaleFirstNames.length)];
        
        const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
        const patronymic = useSex === 1
          ? malePatronymics[Math.floor(Math.random() * malePatronymics.length)]
          : femalePatronymics[Math.floor(Math.random() * femalePatronymics.length)];
        const qualification = qualifications[Math.floor(Math.random() * qualifications.length)];

        sportsmen.push({
          tournament: this.tournamentOne.data.item.id,
          name: `${lastName} ${firstName} ${patronymic}`,
          bdate: birthYear,
          organization: organizations[0],
          qualification: qualification,
          sex: useSex,
          weight: weight,
          coach: coaches[0],
          trainer2: '',
          category_id: firstCategory.id,
          oblast: regions[0],
        });

        // Відправляємо спортсменів по одному
        console.log('Починаємо створення 25 тестових спортсменів...');

        for (let i = 0; i < sportsmen.length; i++) {
          try {
            await this.$store.dispatch('tournament/addSportsman', sportsmen[i]);
            successCount++;
            console.log(`✅ ${i + 1}/25: ${sportsmen[i].name} - додано`);
          } catch (error) {
            failCount++;
            console.error(`❌ ${i + 1}/25: ${sportsmen[i].name} - помилка`, error);
          }
        }

        // Оновлюємо дані
        await this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id});

        // Повідомлення
        this.$notify({
          group: 'foo',
          title: `Тестові дані додано`,
          text: `Успішно: ${successCount}, Помилок: ${failCount}`,
          type: 'success',
        });

        console.log(`✅ Завершено! Успішно: ${successCount}, Помилок: ${failCount}`);
        } finally {
          // Завжди вимикаємо завантаження після завершення
          this.isLoadingTestData = false;
        }
      },

    }
  }
</script>


<style scoped>
/* Нейтральна палітра: без синьо-жовтих акцентів, кольори лише для статусів */
.tab-sportsmans {
  /* перекриває .tournament-content-tab { background:#fff } з _custom.scss */
  background: transparent;
  font-family: var(--tkd-font);
  color: var(--tkd-text);
  --sp-ok: #067647;
  --sp-ok-bg: #ecfdf3;
  --sp-ok-border: #abefc6;
  --sp-ok-strong: #17b26a;
  --sp-warn: #b54708;
  --sp-warn-bg: #fffaeb;
  --sp-warn-strong: #f79009;
  --sp-danger: #b42318;
  --sp-danger-bg: #fef3f2;
  --sp-danger-border: #fecdca;
  --sp-focus: 0 0 0 3px rgba(10, 31, 68, 0.18);
}

.panel {
  background: var(--tkd-surface);
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  box-shadow: var(--tkd-shadow);
  padding: 20px 22px;
  margin-bottom: 16px;
}

/* Шапка */
.sp-head-main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.sp-title { flex: 1 1 320px; min-width: 0; }

.sp-title h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 800;
  color: var(--tkd-text);
}

.sp-count {
  padding: 2px 10px;
  border-radius: 999px;
  background: var(--tkd-bg);
  border: 1px solid var(--tkd-border);
  font-size: 14px;
  font-weight: 700;
  color: var(--tkd-muted);
}

.sp-progress { max-width: 460px; }

.sp-progress-text {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 14px;
  color: var(--tkd-muted);
}

.sp-progress-text b { color: var(--tkd-text); }
.sp-progress-pct { font-weight: 700; color: var(--sp-ok); }

.sp-progress-bar {
  height: 8px;
  border-radius: 999px;
  background: var(--tkd-border);
  overflow: hidden;
}

.sp-progress-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--sp-ok-strong);
  transition: width 0.3s ease;
}

.sp-actions { display: flex; flex-wrap: wrap; gap: 8px; }

.sp-head-bulk {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px dashed var(--tkd-border);
}

.sp-bulk-label { margin-right: 4px; font-size: 13px; font-weight: 700; color: var(--tkd-muted); }

/* Кнопки */
.sp-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 16px;
  border-radius: var(--tkd-radius);
  border: 1.5px solid var(--tkd-border);
  background: var(--tkd-surface);
  font-size: 14px;
  font-weight: 600;
  color: var(--tkd-text);
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s, box-shadow 0.15s;
}

.sp-btn:hover { border-color: var(--tkd-muted); background: var(--tkd-bg); }
.sp-btn:focus-visible { outline: none; box-shadow: var(--sp-focus); border-color: var(--tkd-navy); }
.sp-btn:disabled { opacity: 0.6; cursor: not-allowed; }

.sp-btn-sm { height: 36px; padding: 0 12px; font-size: 13px; }

.sp-btn-primary { border-color: var(--tkd-navy); background: var(--tkd-navy); color: #fff; }
.sp-btn-primary:hover { border-color: var(--tkd-navy-dark); background: var(--tkd-navy-dark); color: #fff; }

.sp-btn-success { border-color: var(--sp-ok-border); background: var(--sp-ok-bg); color: var(--sp-ok); }
.sp-btn-success:hover { border-color: var(--sp-ok-strong); background: var(--sp-ok-bg); }

.sp-btn-danger { border-color: var(--sp-danger-border); background: var(--sp-danger-bg); color: var(--sp-danger); }
.sp-btn-danger:hover { border-color: var(--sp-danger); background: var(--sp-danger-bg); }

.sp-btn-ghost { border-color: transparent; background: transparent; color: var(--tkd-muted); }
.sp-btn-ghost:hover { border-color: var(--tkd-border); color: var(--tkd-text); }

.sp-spin { display: inline-block; animation: spin 1s linear infinite; }

/* Фільтри */
.sp-filter-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.sp-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--tkd-muted);
}

.sp-field >>> .vs__dropdown-toggle {
  min-height: 42px;
  border: 1.5px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
}

/* lbd дає рамку всім input — прибираємо її з поля пошуку v-select */
.sp-field >>> .v-select { border: 0; border-radius: var(--tkd-radius); }
.sp-field >>> .vs__search,
.sp-field >>> .vs__search:focus { border: 0; box-shadow: none; background: transparent; }

.sp-field >>> .vs--open .vs__dropdown-toggle { border-color: var(--tkd-navy); box-shadow: var(--sp-focus); }

.sp-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.segmented {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
  border: 1.5px solid var(--tkd-border);
  overflow-x: auto;
  max-width: 100%;
}

.segmented button {
  height: 34px;
  padding: 0 12px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: var(--tkd-muted);
  white-space: nowrap;
  cursor: pointer;
}

.segmented button:hover { color: var(--tkd-text); background: var(--tkd-surface); }
.segmented button.active { color: #fff; background: var(--tkd-navy); }
.segmented button:focus-visible { outline: none; box-shadow: var(--sp-focus); }

.seg-count {
  margin-left: 4px;
  padding: 0 7px;
  border-radius: 999px;
  background: rgba(10, 31, 68, 0.08);
  font-size: 12px;
}

.segmented button.active .seg-count { background: rgba(255, 255, 255, 0.2); }

.sp-search { position: relative; flex: 1 1 220px; max-width: 340px; }

.sp-search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  font-size: 14px;
  opacity: 0.6;
}

.sp-search input {
  width: 100%;
  height: 42px;
  padding: 0 12px 0 36px;
  border: 1.5px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
  font-size: 14px;
  color: var(--tkd-text);
}

.sp-search input:focus { outline: none; border-color: var(--tkd-navy); box-shadow: var(--sp-focus); background: var(--tkd-surface); }

/* Таблиця */
.sp-table-panel { padding: 0; overflow: hidden; }

.sp-table-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 18px;
  border-bottom: 1px solid var(--tkd-border);
  font-size: 13px;
  color: var(--tkd-muted);
}

.sp-table-meta b { color: var(--tkd-text); }

.sp-legend { display: inline-flex; align-items: center; gap: 6px; }
.lg { display: inline-block; width: 10px; height: 10px; margin-left: 8px; border-radius: 3px; }
.lg-done { background: var(--sp-ok-strong); }
.lg-warn { background: var(--sp-warn-strong); }

/* шапка таблиці лишається видимою під час прокрутки списку */
.sp-table-wrap { max-height: calc(100vh - 140px); overflow: auto; }

.sp-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
}

.sp-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 12px;
  background: var(--tkd-bg);
  border-bottom: 1px solid var(--tkd-border);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  text-align: left;
  color: var(--tkd-muted);
  white-space: nowrap;
}

.sp-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--tkd-border);
  vertical-align: middle;
  color: var(--tkd-text);
}

.sp-table tbody tr { transition: background 0.12s; }
.sp-table tbody tr:nth-child(even) td { background: #fafbfc; }
.sp-table tbody tr:hover td { background: var(--tkd-bg); }

/* смужка статусу зліва */
.sp-table td:first-child { box-shadow: inset 4px 0 0 transparent; }

.verified-sportsman td,
.sp-table tbody tr.verified-sportsman:nth-child(even) td { background: var(--sp-ok-bg); }
.sp-table tbody tr.verified-sportsman:hover td { background: #dcfae6; }
.verified-sportsman td:first-child { box-shadow: inset 4px 0 0 var(--sp-ok-strong); }

.incomplete-sportsman td:first-child { box-shadow: inset 4px 0 0 var(--sp-warn-strong); }

.col-id { width: 1%; white-space: nowrap; font-size: 12px; color: var(--tkd-muted); font-variant-numeric: tabular-nums; }
.col-name { min-width: 200px; font-weight: 700; }
.sp-name-cell { display: flex; align-items: flex-start; gap: 10px; min-width: 0; }
.sp-avatar {
  display: inline-flex;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid var(--tkd-border);
  border-radius: 50%;
  color: var(--tkd-navy);
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0;
  user-select: none;
}
.sp-name-content { min-width: 0; }
.sp-name-text { display: block; overflow-wrap: anywhere; }
.col-check { width: 1%; white-space: nowrap; }
.col-actions { width: 1%; text-align: right; white-space: nowrap; }
.nowrap { white-space: nowrap; }
.muted { color: var(--tkd-muted); }

.missing {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: var(--sp-danger-bg);
  border: 1px solid var(--sp-danger-border);
  font-size: 12px;
  font-weight: 600;
  color: var(--sp-danger);
  white-space: nowrap;
}

.warn-note {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
  color: var(--sp-warn);
}

.chip {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: var(--tkd-bg);
  border: 1px solid var(--tkd-border);
  font-size: 12px;
  font-weight: 600;
  color: var(--tkd-text);
}

/* Перевірка: великий чекбокс з підписом */
.sp-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  margin: 0;
  padding: 0 12px 0 8px;
  border: 1.5px solid var(--tkd-border);
  border-radius: 999px;
  background: var(--tkd-surface);
  font-size: 13px;
  font-weight: 600;
  color: var(--tkd-muted);
  text-transform: none;
  cursor: pointer;
  user-select: none;
}

.sp-check:hover { border-color: var(--tkd-muted); color: var(--tkd-text); }
.sp-check:focus-within { box-shadow: var(--sp-focus); }
.sp-check.on { border-color: var(--sp-ok-border); background: var(--sp-ok-bg); color: var(--sp-ok); }

.input-checkbox {
  width: 20px;
  height: 20px;
  margin: 0;
  accent-color: var(--sp-ok-strong);
  cursor: pointer;
}

.input-checkbox:focus-visible { outline: none; }

/* Дії в рядку */
.row-actions { display: inline-flex; gap: 10px; }

.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1.5px solid var(--tkd-border);
  border-radius: 10px;
  background: var(--tkd-surface);
  font-size: 15px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.icon-edit:hover { border-color: var(--tkd-muted); background: var(--tkd-bg); }
.icon-delete:hover { border-color: var(--sp-danger-border); background: var(--sp-danger-bg); }
.icon-btn:focus-visible { outline: none; box-shadow: var(--sp-focus); }

/* Порожній стан */
.sp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 20px;
  border: 2px dashed var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  background: var(--tkd-surface);
  text-align: center;
  color: var(--tkd-muted);
}

.sp-empty-icon { font-size: 36px; }
.sp-empty p { margin: 0; font-size: 15px; font-weight: 600; }

/* Keep the dense table usable on smaller laptop screens. */
@media (min-width: 992px) and (max-width: 1366px),
       (min-width: 992px) and (max-height: 800px) {
  .panel { padding: 14px 16px; margin-bottom: 12px; }
  .sp-title h3 { margin-bottom: 8px; font-size: 18px; }
  .sp-head-bulk { margin-top: 10px; padding-top: 10px; }
  .sp-btn { height: 36px; padding: 0 12px; font-size: 13px; }
  .sp-btn-sm { height: 32px; padding: 0 10px; font-size: 12px; }
  .sp-filter-bar { margin-top: 10px; gap: 8px; }
  .sp-table-meta { padding: 9px 14px; }
  .sp-table { font-size: 12px; }
  .sp-table th { padding: 8px; font-size: 11px; }
  .sp-table td { padding: 7px 8px; }
  .col-name { min-width: 160px; }
  .sp-check { height: 30px; gap: 5px; padding: 0 8px 0 6px; font-size: 12px; }
  .input-checkbox { width: 16px; height: 16px; }
  .row-actions { gap: 6px; }
  .icon-btn { width: 30px; height: 30px; font-size: 13px; }
}

@media (max-width: 991px) {
  .sp-filter-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 767px) {
  .panel { padding: 16px; }
  .sp-table-panel { padding: 0; }
  .sp-actions, .sp-actions .sp-btn { width: 100%; }
  .sp-actions .sp-btn { justify-content: center; }
  .sp-search { max-width: none; flex-basis: 100%; }
  .sp-table-wrap { max-height: none; }
  .sp-table th { position: static; }
}

@media (max-width: 480px) {
  .sp-filter-grid { grid-template-columns: 1fr; }
  .sp-head-bulk .sp-btn { flex: 1 1 100%; justify-content: center; }
}

@media (prefers-reduced-motion: reduce) {
  .sp-spin { animation: none; }
  .sp-progress-bar span, .sp-btn, .icon-btn, .sp-table tbody tr { transition: none; }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>
